import { CashOfferAddressInput } from 'components/shared/CashOfferAddressInput';
import { CashOfferCard } from 'components/shared/CashOfferCard';

export const PdpCashOfferCard = () => (
  <CashOfferCard headingId="pdp-cash-offer-heading">
    <CashOfferAddressInput
      trackingTaxonomy="pdp_cash_offer"
      originSurface="pdp"
      analyticsName="pdp-cash-offer-submit"
    />
  </CashOfferCard>
);
